export default "__VITE_ASSET__CiMuqIE3__"